<template>
  <div class="f-row ctr company-box">
    <div class="f-row ctr company-brand">
      <!-- <img src="#" alt="Brand" /> -->
    </div>
    <div class="f-col ctr company-info">
      <span>{{ companyName }}</span>
      <!-- <span>Imobiliária</span> -->
    </div>
    <button class="f-row ctr company-settings">
      <span class="hidden"></span>
      <Icon icon="cog" />
    </button>
  </div>
</template>

<script>
export default {
  name: "CompanyBox",
  computed: {
    companyName() {
      return this.$store.state.context?.company;
    },
  },
};
</script>

<style scoped>
.company-box {
  justify-content: space-between;
  width: 100%;
}

.company-brand {
  height: 48px;
  max-height: 48px;
  min-height: 48px;
  width: 48px;
  max-width: 48px;
  min-width: 48px;
  margin-right: 12px;
  background: #364656;
  border-radius: 0.25rem;
}

.company-info {
  align-items: flex-start;
}

.company-info > span {
  margin: 2px 0;
}

.company-info > span:nth-of-type(1) {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.company-info > span:nth-of-type(2) {
  font-size: 12px;
  font-weight: 400;
}

.company-settings {
  margin-left: auto;
  padding: 8px;
  border-radius: 0.25rem;
}

.company-settings:hover {
  background: #364656;
}

.company-settings > svg {
  font-size: 18px;
}
</style>